import React from 'react';
import styled from 'styled-components';
import { DateRangePicker } from 'venn-ui-kit';
import { FREQUENCY_DATEPICKER_MODES, withSuspense } from 'venn-utils';
import { useRecoilState } from 'recoil';
import { globalDateRange } from 'venn-state';

const TopBarDateRange = () => {
  const [dateRange, setDateRange] = useRecoilState(globalDateRange);

  return (
    <DateRangeWrapper>
      <DateRangeLabel>Date Range /</DateRangeLabel>
      <DateRangePicker
        value={dateRange.range}
        range={dateRange.maxRange}
        onChange={(range) => setDateRange((current) => ({ ...current, range }))}
        granularity={FREQUENCY_DATEPICKER_MODES[dateRange.frequency]}
        altStyle
        usePortal
      />
    </DateRangeWrapper>
  );
};

export default withSuspense(<div />, TopBarDateRange);

const DateRangeLabel = styled.div`
  margin-right: 4px;
  white-space: nowrap;
  @media only screen and (max-width: 1400px) {
    display: none;
  }
`;

const DateRangeWrapper = styled.div`
  display: flex;

  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
`;
